import React from 'react';
import '../assets/styles/Contact.scss';
import { InlineWidget } from 'react-calendly';

function Contact() {
  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Book a Meeting</h1>
          <p>Schedule a time that works for you directly on my Calendly!</p>
          
          <InlineWidget url="https://calendly.com/petarburic554/30min" />
        </div>
      </div>
    </div>
  );
}

export default Contact;
